import {
    DoDateServices,
    doHeader,
  } from "./Services.Interface";
  import axios from "axios";
import { ResultadoEncuestaSatisfaccionResponse } from "./ResultadoEncuestaSatisfaccion.Payload";
  
  type responseServiceType = {
    body: any;
  };
  
  type responseType = {
    stateCode: string | undefined;
    message: string | undefined;
    completResponse: any;
  };
  
  type responseErrorType = {
    code: number;
    messageError: string;
  };
  
  
  /**
   * Función genérica para invocar los servicios responderEncuesta
   *
   * @param doDateServices Datos de configuración del servicio y payload request:any
   */
  export const invokeResponderEncuestaService = async (
    doDataServices: DoDateServices
  ) => {
    let resp: ResultadoEncuestaSatisfaccionResponse | undefined;
    let errorService: responseErrorType | undefined;
    const flujo = sessionStorage.getItem("flujos");

  
    try {
      //Consume el servicio y genera la respuesta
      const requestHeaders: {
        "Content-Type": string;
        Authorization: string;
        Accept: string;
        AcceptCRC: string;
        "X-MY-SKY-SESSION-ID"?: string;
        "X-MY-SKY-ACCOUNT-NUMBER"?: string;
      } = {
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: "",
        Accept: "application/json",
        AcceptCRC: "",
      };
  
      if (sessionStorage.getItem("tonpla")) {
        requestHeaders["X-MY-SKY-SESSION-ID"] =
          sessionStorage.getItem("tonpla") ?? "";
      }
  
      if (sessionStorage.getItem("tonpla")) {
        requestHeaders["X-MY-SKY-ACCOUNT-NUMBER"] =
        flujo === "Sky+"
        ? sessionStorage.getItem("cuenta")!
        : sessionStorage.getItem("cuenta")! ?? "";
      }
      const response = await axios({
        url: `${doDataServices.url}/${doDataServices.serviceName}`,
        method: doDataServices.method,
        data: doDataServices.request,
        headers: requestHeaders,
      });
  
      //Obtiene la respuesta de Axios y la transforma a un tipo de dato genérico
      resp = response.data;

    } 
    catch (error: any) {
      console.error(error);
      
      
      
      //Se actualiza en estado de error de servicio a -1
      //: es el código genérico para indicar que ocurrió un error en el llamado al servicio
      errorService=({
        code: -1,
        messageError:
          "Por el momento no podemos atender tu solicitud, por favor intentalo mas tarde.", //error.message
      });
    }
  
    return {
        resp,
      errorService,
    };
  };
  
  